window.addEventListener("DOMContentLoaded",()=>{

    const button=document.querySelector(".menu-trigger");

    const overlay=document.querySelector(".bymoqa-menu-overlay");

    const closeButton = document.querySelector(".bymoqa-menu-close");

    if(closeButton){

    closeButton.addEventListener("click",()=>{

        document.body.classList.remove("bymoqa-menu-open");

    });

    } 

    if(!button) return;

    button.addEventListener("click",()=>{

        document.body.classList.add("bymoqa-menu-open");

    });

    overlay.addEventListener("click",()=>{

        document.body.classList.remove("bymoqa-menu-open");

    });

    document.addEventListener("keydown",(e)=>{

        if(e.key==="Escape")
            document.body.classList.remove("bymoqa-menu-open");

    });

});